var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 11.5835C4.7571 12.603 5.7881 13.3335 7 13.3335C8.2119 13.3335 9.2429 12.603 9.625 11.5835",
    stroke: "#006580",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00028 1.16699C7.4246 1.16701 7.83366 1.22955 8.22099 1.34375C7.93563 1.58883 7.68978 1.87877 7.4954 2.20312C7.33357 2.17865 7.16817 2.167 7.00028 2.16699C5.11955 2.16699 3.56391 3.75475 3.56376 5.75293V6.16406C3.56369 6.75186 3.39533 7.32844 3.07939 7.82031L2.43388 8.82617C2.01591 9.47714 2.34944 10.3377 3.03544 10.5322C5.63103 11.2669 8.36955 11.2669 10.9651 10.5322C11.651 10.3377 11.9844 9.47709 11.5667 8.82617L10.9212 7.82031C10.8531 7.71428 10.7927 7.60338 10.7386 7.49023C11.0942 7.46629 11.4346 7.38891 11.7532 7.2666C11.756 7.27106 11.7592 7.27584 11.762 7.28027L12.4085 8.28613C13.1696 9.47219 12.6024 11.1084 11.2366 11.4951C8.46329 12.28 5.53729 12.28 2.76396 11.4951C1.39803 11.1085 0.830778 9.47223 1.59208 8.28613L2.23856 7.28027C2.44972 6.95153 2.56369 6.56252 2.56376 6.16406V5.75293C2.56391 3.23785 4.53253 1.16699 7.00028 1.16699Z",
    fill: "#006580"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 4.0002,
    r: 2.8,
    fill: "#C35245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bellNotification.e9caa192b0ee8686c59ba3e30dcaab55.svg";
export { ForwardRef as ReactComponent };